/**
 * A simple controller to manage the title and colour of the features pane.
 */
import {IFeatureState} from "../services/feature_state";
import {_t} from "../utility/i18n";
import {ISharedFeatureControlState} from "../services/ISharedFeatureState";

interface IFeaturesPaneScope extends ng.IScope {
    featuresPaneIcon: () => { [key: string] : boolean; }|string;
    sharedState(): ISharedFeatureControlState;
    titleClass(): string|object;
}

export class FeaturesPaneControl {
    public static $inject = ['$scope', 'featureState'];

    constructor($scope: IFeaturesPaneScope, featureState: IFeatureState) {
        $scope.sharedState = () => featureState.sharedState();

        $scope.titleClass = () => {
            return $scope.sharedState().activeReport ? 'bg-feature-report' : 'bg-add-features';
        };

        $scope.featuresPaneIcon = () => {
            const icon = _t('App.ADD_FEATURES_ICON', 'icon-report-doc');
            const result = { icon: true }
            result[icon] = true;
            return result;
        };
    }
}
